/* Optional per-menu prefix filter. Does not replace the main mega-menu script. */
(() => {
  if (customElements.get('pc-brand-search')) return;
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase();
  customElements.define('pc-brand-search', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    init() {
      this.menu = this.closest('pclan-mega-menu');
      this.nav = this.closest('.pc-mm__categories');
      this.input = this.querySelector('input');
      this.status = this.querySelector('[role="status"]');
      if (!this.menu || !this.nav || !this.input || !this.status) return;
      this.items = Array.from(this.nav.querySelectorAll('[data-category]'));
      this.controller?.abort();
      this.controller = new AbortController();
      const on = (node, type, fn, extra = {}) => node.addEventListener(type, fn, { signal: this.controller.signal, ...extra });
      on(this.input, 'input', () => this.filter());
      on(this.nav, 'keydown', event => {
        if (event.target === this.input) {
          if (event.key === 'ArrowDown') {
            event.preventDefault(); event.stopImmediatePropagation();
            this.visible()[0]?.focus();
          } else if (event.key === 'Enter') {
            event.preventDefault(); event.stopImmediatePropagation();
            this.visible()[0]?.focus();
          } else if (event.key === 'Escape' && this.input.value) {
            event.preventDefault(); event.stopImmediatePropagation();
            this.input.value = ''; this.filter();
          }
          return;
        }
        const category = event.target.closest('[data-category]');
        if (!category || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        const items = this.visible(), index = items.indexOf(category);
        if (index < 0) return;
        event.preventDefault(); event.stopImmediatePropagation();
        let next = index;
        if (event.key === 'ArrowDown') next = (index + 1) % items.length;
        if (event.key === 'ArrowUp') next = (index - 1 + items.length) % items.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = items.length - 1;
        items[next].focus(); items[next].scrollIntoView({ block: 'nearest' });
      }, { capture: true });
      const disclosure = this.menu.querySelector('.pc-mm__disclosure');
      if (disclosure) on(disclosure, 'toggle', () => { if (!disclosure.open) this.clear(); });
    }
    visible() { return this.items.filter(item => !item.hasAttribute('data-brand-filtered')); }
    filter() {
      const query = normalize(this.input.value);
      this.items.forEach(item => {
        const title = item.querySelector('span')?.textContent || item.textContent;
        item.toggleAttribute('data-brand-filtered', !normalize(title).startsWith(query));
      });
      const items = this.visible();
      this.menu.toggleAttribute('data-brand-no-results', items.length === 0);
      this.status.hidden = !query;
      this.status.textContent = query ? (items.length ? `${items.length} matching brand${items.length === 1 ? '' : 's'}` : 'No matching brands.') : '';
      this.nav.scrollTop = 0;
      if (!items.length) this.menu.cancelProducts?.();
      else if (typeof this.menu.select === 'function') this.menu.select(items[0].dataset.category, true);
    }
    clear() {
      if (this.input) this.input.value = '';
      this.items?.forEach(item => item.removeAttribute('data-brand-filtered'));
      this.menu?.removeAttribute('data-brand-no-results');
      if (this.status) { this.status.hidden = true; this.status.textContent = ''; }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.clear();
    }
  });
})();
